module.exports = __webpack_public_path__ + "static/media/icon-pdf.849afa03.svg";